/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tour_Layout_DescInputs */

const en_wc_tour_layout_desc = /** @type {(inputs: Wc_Tour_Layout_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop caps, text wrapping, automatic hyphenation, line numbers and page borders.`)
};

/**
* | output |
* | --- |
* | "Drop caps, text wrapping, automatic hyphenation, line numbers and page borders." |
*
* @param {Wc_Tour_Layout_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tour_layout_desc = /** @type {((inputs?: Wc_Tour_Layout_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tour_Layout_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tour_layout_desc(inputs)
});
export { wc_tour_layout_desc as "wc.tour.layout.desc" }